export default __webpack_public_path__ + "static/media/047-bubble tea.3ee51992.svg";